<template>
  <aside class="left-sidebar">
    <div class="scroll-sidebar">
      <nav class="sidebar-nav">
        <ul id="sidebarnav">
          <li v-if="connectedToUserApp" class="sidebar-item">
            <b-link :href="user_app_url" class="sidebar-link waves-effect waves-dark sidebar-link">
              <div>
                <b-icon class="icon-menu" icon="phone"/>
              </div>
              <div>
                <span class="hide-menu">Go To User App</span>
              </div>
            </b-link>
          </li>
          <li
              v-for="(item, index) in visibleMenuItems"
              :key="index"
              class="sidebar-item"
          >
            <b-link
                :to="{name: item.route}"
                class="sidebar-link waves-effect waves-dark sidebar-link"
            >
              <div>
                <b-icon class="icon-menu" :icon="item.icon"/>
              </div>
              <div>
                <span class="hide-menu">{{ item.title }}</span>
              </div>
            </b-link>
            <ul v-if="item.children" class="sidebar-item-submenu">
              <li
                  v-for="(childItem, childIndex) in item.children"
                  :key="childIndex"
                  class="sidebar-item"
              >
                <b-link
                    :to="{name: childItem.route}"
                    class="sidebar-link waves-effect waves-dark sidebar-link"
                >
                  <span>{{ childItem.title }}</span>
                </b-link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </div>
  </aside>
</template>

<script>
export default {
  name: "AdminSidebar",
  data() {
    return {
      menu_items: [
        {
          title: "Dashboard",
          route: "admin-dashboard",
          icon: "house"
        },
        {
          title: "Applications",
          route: "admin-applications",
          icon: "envelope"
        },
        {
          title: "Companies",
          route: "admin-companies",
          icon: "bank"
        },
        {
          title: "Users",
          route: "admin-users",
          icon: "person"
        },
        {
          title: "Listings",
          route: "admin-listings",
          icon: "stickies"
        },
        // {
        //   title: "Items",
        //   route: "admin-items",
        //   icon: "box"
        // },
        {
          title: "Orders",
          route: "admin-orders",
          icon: "cart"
        },
        {
          title: "CTS Schedule Upload",
          route: "admin-cts-schedule-upload",
          icon: "calendar-week"
        },
        {
          title: "CTS Driver & Vehicle Upload",
          route: "admin-cts-fleet-upload",
          icon: "truck"
        },
        {
          title: "Brands",
          route: "admin-brands",
          icon: "collection"
        },
        {
          title: "Generate Marketing Email",
          route: "admin-generate-marketing-email",
          icon: "megaphone"
        },
        {
          title: "Taxonomies",
          route: "admin-taxonomies",
          icon: "inboxes",
          children: [
            {
              title: "Category Types",
              route: "admin-category-types"
            },
            {
              title: "Categories",
              route: "admin-categories"
            },
            {
              title: "Subcategories",
              route: "admin-subcategories"
            },
            {
              title: "Production Types",
              route: "admin-production-types"
            },
            {
              title: "Strain Types",
              route: "admin-strain-types"
            },
            {
              title: "Strains",
              route: "admin-strains"
            },
            {
              title: "Category Images",
              route: "admin-category-images"
            },
            {
              title: "Non-METRC Taxonomy",
              route: "admin-non-metrc-taxonomy"
            },
          ]
        },
        {
          title: "Shipping",
          route: "admin-shipping",
          icon: "truck",
          children: [
            {
              title: "Shippers",
              route: "admin-shippers"
            },
            {
              title: "Shipper Prices",
              route: "admin-shipper-prices"
            },
          ]
        },
        {
          title: "Reports",
          route: "admin-reports",
          icon: "clipboard-data",
          children: [
            {
              title: "Sales by Date",
              route: "admin-report-sales-by-date"
            },
            {
              title: "New & Repeat Orders",
              route: "admin-report-new-repeat-orders"
            },
            {
              title: "Sales by Category",
              route: "admin-report-sales-by-category"
            },
            {
              title: "Sellers by Date",
              route: "admin-report-sellers-by-date"
            },
            {
              title: "Buyers by Date",
              route: "admin-report-buyers-by-date"
            },
            {
              title: "Sellers Activity",
              route: "admin-report-seller-activity"
            },
            {
              title: "Buyers Activity",
              route: "admin-report-buyers-activity"
            },
            {
              title: "Inventory Coverage",
              route: "admin-report-inventory-coverage"
            },
            {
              title: "Performance & Alerts",
              route: "admin-report-performance-alerts"
            },
            {
              title: "Brand Health Scoring",
              route: "admin-report-brand-health-scoring"
            },
            {
              title: "Account Billing Status",
              route: "admin-report-account-billing-status"
            },
            {
              title: "Account Monthly Revenue",
              route: "admin-report-account-monthly-revenues"
            },
            {
              title: "Incomplete Applications",
              route: "admin-report-incomplete-applications"
            },
            {
              title: "Public Menu Sharing",
              route: "admin-report-public-menu-sharing"
            }
          ]
        },
        {
          title: "Price Limits",
          route: "admin-price-limits",
          icon: "currency-dollar"
        },
        {
          title: "Payment Methods",
          route: "admin-payment-method-settings",
          icon: "credit-card"
        },
        {
          title: "Pricing Plans",
          route: "admin-pricing-plans",
          icon: "cash-coin"
        },
        {
          title: "AI Usage",
          route: "admin-ai-usage",
          icon: "bar-chart"
        },
        {
          title: "Billing",
          route: "admin-billing",
          icon: "coin"
        },
        {
          title: "State Licenses",
          route: "admin-state-licenses",
          icon: "card-list"
        },
        {
          title: "License Registry",
          route: "admin-license-registry",
          icon: "shield-check"
        },
        {
          title: "App Notifications",
          route: "admin-app-notifications",
          icon: "bell"
        },
        {
          title: "Universal Directory",
          route: "admin-universal-directory",
          icon: "person-lines-fill"
        },
      ],
      user_app_url: process.env.MIX_USER_APP_URL
    }
  },
  computed: {
    visibleMenuItems() {
      const items = this.menu_items.slice();
      if (this.$store.state.auth.user.is_super_admin) items.push({ title: 'Activity Checklists', route: 'admin-activity-checklists', icon: 'list-check' });
      return items;
    },
    connectedToUserApp() {
      return !! this.$store.state.auth.user.company;
    }
  }
}
</script>
